import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IUpdateWorkflow extends IBaseEntity {
    id: number;
    type: any;
    workflowConditions: any;
    workflowUpdates: any;
    activated: any;
    runInterval: any;
    startTime: any;
    endTime: any;
    wdaysOfWeek: any;
    mweekOfMonth: any;
    mmonthsOfYear: any;
    mdaysOfMonth: any;
    useLastUpdate: any;
    useCreatedOn: any;
    useEvent: any;
    description: any;
    whatsAppTemplate: any;
    useSchedule: any;
    sqlQuery: any;
    scheduledAt?: string;
}

export class UpdateWorkflow extends BaseEntity implements IUpdateWorkflow {
    id: number;
    type: any;
    workflowConditions: any;
    workflowUpdates: any;
    activated: any;
    runInterval: any;
    startTime: any;
    endTime: any;
    wdaysOfWeek: any;
    mweekOfMonth: any;
    mmonthsOfYear: any;
    mdaysOfMonth: any;
    useLastUpdate: any;
    useCreatedOn: any;
    useEvent: any;
    description: any;
    whatsAppTemplate: any;
    useSchedule: any;
    sqlQuery: any;
    constructor(emailWorkflow?) {
        super();
        if (emailWorkflow) {
            this.id = emailWorkflow.id;
            this.type = emailWorkflow.type;
            this.activated = emailWorkflow.activated;
            this.workflowConditions = emailWorkflow.workflowConditions;
            this.workflowUpdates = emailWorkflow.workflowUpdates;
            this.runInterval = emailWorkflow.runInterval;
            this.startTime = emailWorkflow.startTime;
            this.endTime = emailWorkflow.endTime;
            this.wdaysOfWeek = emailWorkflow.wdaysOfWeek;
            this.mweekOfMonth = emailWorkflow.mweekOfMonth;
            this.mmonthsOfYear = emailWorkflow.mmonthsOfYear;
            this.mdaysOfMonth = emailWorkflow.mdaysOfMonth;
            this.useLastUpdate = emailWorkflow.useLastUpdate;
            this.useCreatedOn = emailWorkflow.useCreatedOn;
            this.useEvent = emailWorkflow.useEvent;
            this.description = emailWorkflow.description;
            this.whatsAppTemplate = emailWorkflow.whatsAppTemplate;
            this.useSchedule = emailWorkflow.useSchedule;
            this.sqlQuery = emailWorkflow.sqlQuery;
        }
    }

    clone(): UpdateWorkflow {
        return new UpdateWorkflow(this);
    }
}
